export const buttonVariants = ['primary', 'secondary', 'ghost', 'outline', 'linkButton'] as const;
export type ButtonVariant = (typeof buttonVariants)[number];

export const buttonSizes = ['sm', 'md'] as const;
export type ButtonSize = (typeof buttonSizes)[number];

export interface ButtonCommonBaseProps {
	readonly disabled?: boolean;
	readonly isLoading?: boolean;
	readonly variant?: ButtonVariant;
	readonly size?: ButtonSize;
	readonly isFullWidth?: boolean;
	readonly ctaGroupPos?: 'left' | 'center' | 'right';
	readonly hasNoPaddingX?: boolean;
	readonly hasNoStyles?: boolean;
	readonly noRadius?: boolean;
}

export interface ButtonWithoutIconBaseProps extends ButtonCommonBaseProps {
	readonly hasOnlyIcon?: false;
}

// Require aria-label for better accessibility,
// when only icon set as button content
export interface ButtonWithIconBaseProps extends ButtonCommonBaseProps {
	readonly hasOnlyIcon: true;
	readonly 'aria-label': string;
}

export type ButtonBaseProps = ButtonWithoutIconBaseProps | ButtonWithIconBaseProps;
